import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import {
  makeStyles,
  Grid,
  Typography,
  MenuItem,
  Box,
  InputLabel,
  FormControl,
  Divider,
  List,
  Select,
  ListItem,
  ListItemText,
} from "@material-ui/core";

import { TextField } from "formik-material-ui";

import { Alert } from "@material-ui/lab";
import { Formik, Form, Field } from "formik";

import { getYear } from "src/redux/actions/year.action";

import { useSelector, useDispatch } from "react-redux";
import CustomSelectInput from "src/components/inputs/CustomSelectInput";

import Swal from "sweetalert2";
import _ from "lodash";
import clsx from "clsx";
import { httpClient } from "src/utils/HttpClient";
import { apiUrl } from "src/Constants";
import Moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  inputDisabledForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
    backgroundColor: "#D3D3D3",
    borderRadius: 4,
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
  rootList: {
    width: "25ch",
    maxWidth: 360,
    backgroundColor: "#D3D3D3",
    position: "relative",
    overflow: "auto",
    maxHeight: 300,
  },
  listSection: {
    backgroundColor: "inherit",
  },
  ul: {
    backgroundColor: "inherit",
    padding: 0,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const ContractCreateForm = ({
  history,
  bindSubmitForm,
  initialValues = {
    PR_NO: "",
  },
  status,
  handleSubmitForm,
  year,
  suppliers,
}) => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const {
    result: {
      email,
      companyid,
      countryid,
      company,
      country,
      currencyid,
      department,
      brand,
      department_id,
      brand_id,
      fullname,
    },
  } = useSelector((state) => state.loginReducer);

  const { years, purchaseRequest } = useSelector(
    (state) => state.purchaseRequestReducer
  );

  const { allBrands, allDepartments } = useSelector(
    (state) => state.referenceReducer
  );

  const renderYear = () => {
    if (years.isLoading) {
      return <MenuItem>Loading...</MenuItem>;
    }

    return years.data.map((item) => (
      <MenuItem MenuItem={item.YEAR_CODE} value={item.YEAR_CODE}>
        {item.YEAR_CODE}
      </MenuItem>
    ));
  };

  const renderBrandName = (data) => {
    if (allBrands.isLoading) {
      return <>{"Loading..."}</>;
    }

    const result = _.find(allBrands.data, {
      REF_ID: data,
    });

    if (result) {
      return result.REF_NAME;
    }
    return "";
  };

  const renderDepartmentName = (data) => {
    if (allDepartments.isLoading) {
      return <>{"Loading..."}</>;
    }

    const result = _.find(allDepartments.data, {
      REF_ID: data,
    });

    if (result) {
      return result.REF_NAME;
    }
    return "";
  };

  return (
    <Fragment>
      <Formik
        key={`PurchaseHeadForm`}
        enableReinitialize
        initialValues={{
          ...initialValues,
          PR_TYPE: initialValues.PR_TYPE ? initialValues.PR_TYPE : 1,
          REF_PR_NO: initialValues.REF_PR_NO ? initialValues.REF_PR_NO : "",
          PR_VENDOR: initialValues.PR_VENDOR ? initialValues.PR_VENDOR : "",
          PR_COMPIDX_NAME: initialValues.PR_COMPIDX_NAME
            ? initialValues.PR_COMPIDX_NAME
            : company,
          PR_COUNTRYID_NAME: initialValues.PR_COUNTRYID_NAME
            ? initialValues.PR_COUNTRYID_NAME
            : country,
          PR_NO: initialValues.PR_NO ? initialValues.PR_NO : "",
          PR_BRANDID: initialValues.PR_BRANDID
            ? initialValues.PR_BRANDID
            : brand_id,
          PR_BRAND_NAME: initialValues.PR_BRANDID
            ? renderBrandName(initialValues.PR_BRANDID)
            : brand,
          PR_DEPARTID: initialValues.PR_DEPARTID
            ? initialValues.PR_DEPARTID
            : department_id,
          PR_DEPART_NAME: initialValues.PR_DEPARTID
            ? renderDepartmentName(initialValues.PR_DEPARTID)
            : department,
          PR_YEAR: initialValues.PR_YEAR ? initialValues.PR_YEAR : "",
          PR_STATUS: initialValues.PR_STATUS ? initialValues.PR_STATUS : "",
          POSTED_DATE: initialValues.POSTED_DATE
            ? initialValues.POSTED_DATE
            : "",
          POSTED_NAME: initialValues.POSTED_NAME
            ? initialValues.POSTED_NAME
            : fullname,
          POSTED_EMAIL: initialValues.POSTED_EMAIL
            ? initialValues.POSTED_EMAIL
            : email,
          PR_COMPIDX: companyid ? companyid : "",
          PR_CURRENCY: currencyid ? currencyid : "",
          REF_CODE_PR: "",
          CREATED_NAME: initialValues.CREATED_NAME
            ? initialValues.CREATED_NAME
            : "",
          TELEPHONE: initialValues.TELEPHONE ? initialValues.TELEPHONE : "",
          APPROVE_BY: initialValues.APPROVE_BY ? initialValues.APPROVE_BY : "",
          APPROVE_DATE: initialValues.APPROVE_DATE
            ? initialValues.APPROVE_DATE
            : "",
          REMARK: initialValues.REMARK ? initialValues.REMARK : "",
          REMARK_JOB: initialValues.REMARK_JOB ? initialValues.REMARK_JOB : "",
          SHOW_CREATED_DATE: initialValues.CREATED_DATE
            ? initialValues.CREATED_DATE
            : "",
          ASSIGN_DATE_SHOW: initialValues.ASSIGN_DATE
            ? initialValues.ASSIGN_DATE
            : "",
          REQUIRE_CONTRACT: initialValues.REQUIRE_CONTRACT
            ? initialValues.REQUIRE_CONTRACT
            : 0,
        }}
        validate={(values) => {
          const errors = {};

          if (!values.PR_YEAR) {
            errors.PR_YEAR = "Required";
          }

          if (!values.PR_YEAR) {
            errors.PR_YEAR = "Required";
          }

          if (values.PR_TYPE === 2 && !values.REF_PR_NO) {
            errors.REF_PR_NO = "Required";
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            if (values.PR_TYPE === 2 && !purchaseRequest.data.REF_PR_NO) {
              httpClient
                .get(
                  `${apiUrl}/purchase-request/find-detail-refcode/${values.PRHIDX}/${countryid}/${currencyid}/${values.REF_PR_NO}`
                )
                .then((result) => {
                  if (result.data) {
                    const { icon, data, message } = result.data;

                    if (icon === "success") {
                      values.REF_PR_NO = data.PR_NO;
                      handleSubmitForm(values);
                    } else if (icon === "warning") {
                      Swal.fire({
                        text: message,
                        icon: icon,
                      });
                    }
                  }
                })
                .catch((err) => {
                  Swal.fire({
                    text: err.message,
                    icon: "error",
                  });
                });
            } else {
              handleSubmitForm(values);
            }

            setSubmitting(false);
          }, 500);
        }}
      >
        {(formikProps) => {
          const { handleSubmit, setFieldValue, values, errors, touched } =
            formikProps;

          bindSubmitForm(formikProps.submitForm);

          return (
            <Form noValidate onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <Box display="flex" component="div" flexGrow={1} flex={1}>
                    <Alert
                      icon={false}
                      variant="filled"
                      severity="info"
                      style={{ width: "100%" }}
                    >
                      <Typography component="h2">
                        Purchase Requisition information
                      </Typography>
                    </Alert>
                  </Box>
                  <Box
                    display="flex"
                    component="div"
                    flexGrow={1}
                    flex={1}
                    flexDirection="row"
                    flexWrap="wrap"
                  >
                    <Box m={1} flexGrow={1}>
                      <div>
                        <FormControl
                          className={clsx(classes.inputForm, {
                            [classes.inputDisabledForm]: Boolean(
                              values.PR_STATUS >= 10
                            ),
                          })}
                        >
                          <InputLabel id="select-brand-label">
                            Document Status
                          </InputLabel>
                          <Field
                            component={CustomSelectInput}
                            name="PR_TYPE"
                            label="Brand"
                            labelId="select-brand-label"
                            onChange={(e) => {
                              setFieldValue("REF_CODE_PR", "");
                            }}
                            readOnly={Boolean(values.PR_STATUS >= 10)}
                          >
                            <MenuItem value={1}>New PR</MenuItem>
                            <MenuItem value={2}>Refered PR</MenuItem>
                          </Field>
                        </FormControl>
                        <Field
                          component={TextField}
                          name="REF_PR_NO"
                          label="Reference PR NO."
                          className={clsx(classes.inputForm, {
                            [classes.inputDisabledForm]: Boolean(
                              values.PR_STATUS >= 10
                            ),
                          })}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: Boolean(
                              values.PR_STATUS >= 10 || values.PR_TYPE === 1
                            ),
                          }}
                          error={Boolean(
                            errors.REF_PR_NO &&
                              touched.REF_PR_NO &&
                              errors.REF_PR_NO
                          )}
                        />
                      </div>
                      <div>
                        <FormControl
                          className={clsx(classes.inputForm, {
                            [classes.inputDisabledForm]: Boolean(
                              values.PR_STATUS >= 10
                            ),
                          })}
                        >
                          <InputLabel id="select-type-label">Type</InputLabel>
                          <Field
                            component={CustomSelectInput}
                            name="PR_VENDOR"
                            label="Type"
                            labelId="select-type-label"
                            onChange={() => {}}
                            readOnly={Boolean(values.PR_STATUS >= 10)}
                          >
                            <MenuItem value={10} selected>
                              PREFER VENDOR
                            </MenuItem>
                            <MenuItem value={20}>COMPARE PRICE</MenuItem>
                            <MenuItem value={30}>BIDDING</MenuItem>
                          </Field>
                        </FormControl>
                        <Field
                          component={TextField}
                          name="PR_COMPIDX_NAME"
                          label="Company"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </div>
                      <div>
                        <Field
                          component={TextField}
                          name="PR_COUNTRYID_NAME"
                          label="Country"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <FormControl
                          className={clsx(classes.inputForm, {
                            [classes.inputDisabledForm]: Boolean(
                              values.PR_STATUS >= 10
                            ),
                          })}
                        >
                          <InputLabel
                            error={Boolean(
                              errors.PR_YEAR &&
                                touched.PR_YEAR &&
                                errors.PR_YEAR
                            )}
                            id="select-year-label"
                          >
                            Budget Year
                          </InputLabel>
                          <Field
                            component={CustomSelectInput}
                            name="PR_YEAR"
                            label="Year"
                            labelId="select-year-label"
                            error={Boolean(
                              errors.PR_YEAR &&
                                touched.PR_YEAR &&
                                errors.PR_YEAR
                            )}
                            onChange={(e) => {
                              e.preventDefault();
                              dispatch(
                                getYear(
                                  countryid +
                                    companyid +
                                    values.PR_BRANDID +
                                    e.target.value
                                )
                              );
                            }}
                            readOnly={Boolean(values.PR_STATUS >= 10)}
                          >
                            {renderYear()}
                          </Field>
                        </FormControl>
                      </div>
                    </Box>
                    <Box m={1} flexGrow={1}>
                      <div>
                        <Field
                          component={TextField}
                          name="PR_NO"
                          label="PR NO."
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <Field
                          component={TextField}
                          name="PR_STATUS"
                          label="Status"
                          select
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        >
                          <MenuItem value={5}>New PR</MenuItem>
                          <MenuItem value={10}>DRAFT</MenuItem>
                          <MenuItem value={20}>POST</MenuItem>
                          <MenuItem value={22}>Reviewed</MenuItem>
                          <MenuItem value={24}>Rejected By Reviewer</MenuItem>
                          <MenuItem value={26}>Held By Reviewer</MenuItem>
                          <MenuItem value={30}>APPROVED</MenuItem>
                          <MenuItem value={35}>HELD BY APPROVER</MenuItem>
                          <MenuItem value={40}>REJECTED BY APPROVER</MenuItem>
                          <MenuItem value={50}>PURCHASING IN PROGRESS</MenuItem>
                          <MenuItem value={51}>VERIFIED PR</MenuItem>
                          <MenuItem value={52}>LEGAL MAKES A DECISION</MenuItem>
                          <MenuItem value={49}>CONTRACT IS REQUIRED</MenuItem>
                          <MenuItem value={53}>
                            CONTRACT IS NOT REQUIRED
                          </MenuItem>
                          <MenuItem value={54}>LEGAL IN PROGRESS</MenuItem>
                          <MenuItem value={55}>
                            FINAL DRAFT IS DONE AND READY TO SIGN OFF
                          </MenuItem>
                          <MenuItem value={56}>CONTRACT IS ATTACHED</MenuItem>
                          <MenuItem value={57}>
                            LEGAL TASK IS COMPLETED
                          </MenuItem>
                          <MenuItem value={58}>CONTRACT IS REJECTED</MenuItem>
                          <MenuItem value={59}>HELD BY LEGAL</MenuItem>
                          <MenuItem value={60}>PURCHASING COMPLETED</MenuItem>
                          <MenuItem value={70}>PURCHASING HOLD</MenuItem>
                          <MenuItem value={80}>PURCHASING REJECTED</MenuItem>
                        </Field>
                      </div>
                      <div>
                        <Field
                          component={TextField}
                          name="SHOW_CREATED_DATE"
                          label="Request Date"
                          className={classes.inputDisabledForm}
                          value={Moment(values.SHOW_CREATED_DATE).format(
                            "DD-MMM-YY"
                          )}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <Field
                          component={TextField}
                          name="REQUIRE_CONTRACT"
                          label="Contract"
                          select
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        >
                          <MenuItem value={0}>No</MenuItem>
                          <MenuItem value={1}>Yes</MenuItem>
                        </Field>
                      </div>
                      <div>
                        <Field
                          component={TextField}
                          name="CONTRACT_NO"
                          label="Contract No"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </div>
                      <div>
                        <Field
                          component={TextField}
                          name="CONTRACT_PERSON_EMAIL"
                          label="Contract Person Email"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <FormControl className={classes.inputDisabledForm}>
                          <InputLabel shrink htmlFor="select-multiple-native">
                            Vendor
                          </InputLabel>
                          <Select
                            multiple
                            native
                            onChange={() => {}}
                            inputProps={{
                              id: "select-multiple-native",
                            }}
                          >
                            {suppliers.map((sectionId) => (
                              <option>
                                {`${
                                  sectionId.SUPCODE ? sectionId.SUPCODE : "N/A"
                                }`}
                                {" - "}
                                {`${
                                  sectionId.SUPNAME ? sectionId.SUPNAME : "N/A"
                                }`}
                              </option>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box
                    display="flex"
                    component="div"
                    flexGrow={1}
                    flex={1}
                    flexDirection="column"
                  >
                    <Box flexGrow={1}>
                      <Box display="flex" component="div" flexGrow={1} flex={1}>
                        <Alert
                          icon={false}
                          variant="filled"
                          severity="info"
                          style={{ width: "100%" }}
                        >
                          <Typography component="h2">
                            User request profile
                          </Typography>
                        </Alert>
                      </Box>
                      <div>
                        <Field
                          component={TextField}
                          name="CREATED_NAME"
                          label="Requester"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <Field
                          component={TextField}
                          name="CREATED_EMAIL"
                          label="E-mail"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </div>
                      <Divider />
                      <div>
                        <Field
                          component={TextField}
                          name="POSTED_NAME"
                          label="Post By"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <Field
                          component={TextField}
                          name="POSTED_EMAIL"
                          label="E-mail (Post By)"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </div>
                      <div>
                        <Field
                          component={TextField}
                          name="PR_BRAND_NAME"
                          label="Brand"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <Field
                          component={TextField}
                          name="PR_DEPART_NAME"
                          label="Department"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </div>
                      <div>
                        <Field
                          component={TextField}
                          name="ASSIGN_PURCHASE_NAME"
                          label="Forward By Purchaser"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <Field
                          component={TextField}
                          name="ASSIGN_DATE"
                          label="Forward Date"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            values.ASSIGN_DATE &&
                            Moment(values.ASSIGN_DATE).format("DD-MMM-YY")
                          }
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </div>
                      <div>
                        <Field
                          component={TextField}
                          name="CONTRACT_LEGAL_RC_NAME"
                          label="Contract is Required By"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <Field
                          component={TextField}
                          name="CONTRACT_LEGAL_RC_DATE"
                          label="Contract is Required Date"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            values.CONTRACT_LEGAL_RC_DATE &&
                            Moment(values.CONTRACT_LEGAL_RC_DATE).format(
                              "DD-MMM-YY"
                            )
                          }
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </div>
                      <div>
                        <Field
                          component={TextField}
                          name="CONTRACT_LEGAL_R_NAME"
                          label="Received By"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <Field
                          component={TextField}
                          name="CONTRACT_LEGAL_RECEIVED_DATE"
                          label="Received Date"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            values.CONTRACT_LEGAL_RECEIVED_DATE &&
                            Moment.utc(values.CONTRACT_LEGAL_RECEIVED_DATE)
                              .local("Asia/Bangkok")
                              .format("DD-MMM-YY")
                          }
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </div>
                      <div>
                        <Field
                          component={TextField}
                          name="CONTRACT_LEGAL_F_NAME"
                          label="Contract Final Version By"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <Field
                          component={TextField}
                          name="CONTRACT_LEGAL_F_DATE"
                          label="Final Version Date"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            values.CONTRACT_LEGAL_F_DATE &&
                            Moment.utc(values.CONTRACT_LEGAL_F_DATE)
                              .local("Asia/Bangkok")
                              .format("DD-MMM-YY")
                          }
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </div>
                      <div>
                        <Field
                          component={TextField}
                          name="CONTRACT_LEGAL_SUB_NAME"
                          label="Submitted By"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <Field
                          component={TextField}
                          name="CONTRACT_LEGAL_SUBMITTED_DATE"
                          label="Submitted Date"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            values.CONTRACT_LEGAL_SUBMITTED_DATE &&
                            Moment.utc(values.CONTRACT_LEGAL_SUBMITTED_DATE)
                              .local("Asia/Bangkok")
                              .format("DD-MMM-YY")
                          }
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </div>
                      <div>
                        <Field
                          component={TextField}
                          name="CONTRACT_LEGAL_C_NAME"
                          label="Completed By"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <Field
                          component={TextField}
                          name="CONTRACT_LEGAL_COMPLETED_DATE"
                          label="Completed Date"
                          className={classes.inputDisabledForm}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            values.CONTRACT_LEGAL_COMPLETED_DATE &&
                            Moment.utc(values.CONTRACT_LEGAL_COMPLETED_DATE)
                              .local("Asia/Bangkok")
                              .format("DD-MMM-YY")
                          }
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </div>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" flex={1} p={2}>
                    <Field
                      component={TextField}
                      name="REMARK"
                      label="Remark"
                      multiline
                      style={{
                        width: "100%",
                      }}
                      rows={4}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className={clsx(classes.inputForm, {
                        [classes.inputDisabledForm]: Boolean(
                          values.PR_STATUS >= 20
                        ),
                      })}
                      InputProps={{
                        readOnly: Boolean(values.PR_STATUS >= 20),
                      }}
                      variant="outlined"
                    />
                  </Box>
                </Grid>
                {values.REMARK_JOB && (
                  <Grid item xs={12} sm={12}>
                    <Box display="flex" component="div" flexGrow={1} flex={1}>
                      <Alert
                        icon={false}
                        variant="filled"
                        severity="info"
                        style={{ width: "100%" }}
                      >
                        <Typography component="h2">Purchasing staff</Typography>
                      </Alert>
                    </Box>
                    <Box display="flex" flex={1} p={2}>
                      <Field
                        component={TextField}
                        name="REMARK_JOB"
                        label="Remark By Purchase Staff"
                        multiline
                        style={{
                          width: "100%",
                        }}
                        rows={4}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        variant="outlined"
                      />
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </Fragment>
  );
};

export default ContractCreateForm;
